import {
    apiRequest,
    AwardPeriodApprove,
    AwardRevoke,
    AwardPeriodExport
} from "../../../../../services/adapters/kepegawaian/penghargaanService"

class ApproveRepository {
    
    fetchApprove = async (query) => {
        return await apiRequest("post", AwardPeriodApprove, {
            body: query
        }, true)
    }

    fetchRevoke = async (query) => {
        return await apiRequest("post", AwardRevoke, {
            body: query
        }, true)
    }

    fetchExport = async (query) => {
        return await apiRequest("get", AwardPeriodExport, {
            params: query
        }, true)
    }

}

export default ApproveRepository